import React from 'react';
import { PartNumberPill } from '../../DropdownEditor/CustomOptions';
import { IPurchaseOrderReceiptLineHelper } from '../../../graphql/schema/p4types';

const ReferenceAndPartNumberContent = ({ partNumber, reference }: { partNumber?: string; reference: string }) => {
  if (!partNumber || reference === partNumber) return <>{reference}</>;

  return (
    <>
      {reference} <PartNumberPill title={partNumber}>{partNumber}</PartNumberPill>
    </>
  );
};

const ReferenceWithSupplierPartNumberPillFormatter = (props) => {
  const { rowData } = props.dependentValues;

  let partNumber;
  if (rowData && rowData.supplierPartNumberOrProductReference) {
    partNumber = rowData.supplierPartNumberOrProductReference;
  }

  let reference = '';
  if (rowData && rowData.product) {
    reference = rowData.product.reference;
  }

  return <ReferenceAndPartNumberContent reference={reference} partNumber={partNumber} />;
};

/**
 * Clone of above with modified keys for use on Purchase Order Receipt, due to use of DTO to add extra meta data.
 */
export const ReceiptLineProductFormatter = (props: {
  dependentValues: { rowData: IPurchaseOrderReceiptLineHelper };
}) => {
  const { rowData } = props.dependentValues;

  const reference = rowData.purchaseOrderLine?.product?.reference ?? '';
  const partNumber: string | undefined = rowData.purchaseOrderLine?.supplierPartNumberOrProductReference ?? undefined;

  return <ReferenceAndPartNumberContent reference={reference} partNumber={partNumber} />;
};

export default ReferenceWithSupplierPartNumberPillFormatter;
